import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  List,
  ListSubHeader,
  ListCheckbox,
  Button,
} from 'react-toolbox'
import CSSModules from 'react-css-modules'
import _ from 'lodash'
import { Flex } from 'reflexbox'

import styles from './styles.scss'

class CheckboxFilter extends Component {
  filterHandlerWithIndex(handler, index) {
    return value => {
      this.props.onUpdateConfig([])
      this.props.onUpdateConfigSource([])
      handler(index, value)
    }
  }

/**
 *
 * Renders the list of filter items
 *
 * @param {Array} filterPair
 * @returns {ReactElement}
 * @memberof CheckboxFilter
 */
  renderFilterItems(filterPair, filterType) {
    const header = filterPair.pop()

    return (
      <List selectable ripple theme={styles}>
        <ListSubHeader caption= {header} theme={styles}/>
        <Flex styleName='filterItemWrapper'>{
          filterPair.map((filter, index) => (
            <ListCheckbox
              caption={filter.label}
              key={index}
              theme={styles}
              onChange={this.filterHandlerWithIndex(this.props.filterHandlers[filterType], filter.value)}
              checked={this.props.filterStatus[filterType][filter.value]}
            />
          ))
        }</Flex>
      </List>
    )
  }
/**
 *
 * Renders filters of all types
 *
 * @returns {ReactElement}
 * @memberof CheckboxFilter
 */
  renderFilters() {
    const filterPairs = this.props.filterPairs
    const filterArr = []

    for (const filterType in filterPairs) {
      if (!filterPairs.hasOwnProperty(filterType)) continue

      filterArr.push(
        <div styleName='filterItem' key={filterType}>
          {this.renderFilterItems(_.cloneDeep(filterPairs[filterType]), filterType)}
        </div>
      )
    }

    return (
      <Flex styleName='filterWrapper'>{filterArr}</Flex>
    )
  }

  render() {
    return (
      <div styleName='filter'>
        <h4 styleName='filterTitle'>Filters:</h4>
        <Button floating mini icon='cached' styleName='filterRefreshBtn' onClick={this.props.onRefreshFilter} />
        {this.renderFilters()}
      </div>
    )
  }
}

CheckboxFilter.propTypes = {
  curConfig: PropTypes.object,

  filterHandlers: PropTypes.object.isRequired,
  filterStatus: PropTypes.object.isRequired,
  filterPairs: PropTypes.object.isRequired,
  onRefreshFilter: PropTypes.func.isRequired,
  onUpdateConfig: PropTypes.func.isRequired,
  onUpdateConfigSource: PropTypes.func.isRequired,
}

export default CSSModules(CheckboxFilter, styles)
